module.exports = __webpack_public_path__ + "img/STM1.078bcba5.jpg";